import React from 'react'
import {Link} from 'react-router-dom';


const Footer = () => {
  return (
    <div>
      <footer>
<section className="contact container" id="contact">
    <div className="main-contact">
        <h3>ModiQ</h3>
        <h5>Let's Connect With Us</h5>
        <div className="icons">
            <a href="#"><i className="fab fa-facebook-square"></i></a>
            <a href="#"><i className="fab fa-instagram-square"></i></a>
            <a href="#"><i className="fab fa-twitter-square"></i></a>
        </div>
    </div>

    <div className="main-contact">
        <h3>Explore</h3>
        <li><a href="#home">Home</a></li>
        <li><a href="#featured">Featured</a></li>
        <li><a href="#new">New</a></li>
        <li><a href="#contact">Contact</a></li>
    </div>

    <div className="main-contact">
        <h3>Our Services</h3>
        <li><a href="#">Pricing</a></li>
        <li><a href="#">Free Shipping</a></li>
        <li><a href="#">Gift Cards</a></li>
    </div>

    <div className="main-contact">
        <h3>Shopping</h3>
        <li><a href="#">Clothing Store</a></li>
        <li><a href="#">Trending Shoes</a></li>
        <li><a href="#">Accessories</a></li>
        <li><a href="#">Sale</a></li>
    </div>

</section>
</footer>

<div className="last-text">
    <p>Copyright © 2024 All rights reserved | This template is made with &hearts;  by Miki developer</p>
</div>
    </div>
  )
}

export default Footer
